var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 62,
  height: 62,
  viewBox: "0 0 60 60",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "white",
  stroke: "white",
  strokeWidth: 2
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.802,
  cx: 30,
  cy: 30,
  r: 28.5,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.5 30l-21 12V18z"
}))));
export default SvgPlay;